import React, { useRef, useState } from 'react';
import './ViewPassenger.css';
import ViewPassengerDetails from './ViewPassengerDetails/ViewPassengerDetails';
import ViewPassengerTours from './ViewPassengerTours/ViewPassengerTours';
import { FaExclamation } from 'react-icons/fa';
import STC from '../../../../../../STCLibrary/STCFactory/STCFactory';

export default function ViewPassenger({ passenger }) {
    const ref = useRef(null);
    const [selectedInfo, setSelectedInfo] = useState(0);

    const infoOptions = [
        <ViewPassengerTours key="tours" passenger={passenger} />,  //change here
        <ViewPassengerDetails key="details" passenger={passenger} /> //change here
    ];

    return (
        <div ref={ref} className='view-passenger-card'>
            <div className='view-passenger-title'>
                <h3>{passenger?.firstName} {passenger?.surname}</h3>
            </div>

            {!passenger?.passport &&<STC.Alert variant='danger' className='m-2'>
                <div><strong>Please enter passport details.</strong></div>
                <div style={{fontStyle: 'italic', fontSize: 12}}>
                    If passport information is not provided 6-weeks from the departure date, the passenger must check in on arrival at the airport at a cost of €65 per person each way. This is an airline charge and is out of our control. 
                </div>
            </STC.Alert>}
            
            <div className={'view-passenger-extra-container active'}>
                <div className='view-passenger-options'>
                    <div 
                        className={selectedInfo === 0 ? 'option-type active' : 'option-type'} 
                        onClick={() => setSelectedInfo(0)}
                    >
                        Tours
                    </div>
                    <div 
                        className={selectedInfo === 1 ? 'option-type active' : 'option-type'} 
                        onClick={() => setSelectedInfo(1)}
                    >
                        Passport 
                        {!passenger?.passport && <FaExclamation data-testid="passport-icon" className="passport-notification" />} 
                    </div>
                </div>
                <div>
                    {infoOptions[selectedInfo]}
                </div>
            </div>
        </div>
    );
}